import {Radio, Stack, TextInput, createStyles} from '@mantine/core';
import React from 'react';

import FormGroup from 'ui-library/bs/FormGroup';
import FieldLabel from 'ui-library/inputs/FieldLabel';

export type BarcodeMode = 'autogenerate' | 'custom' | 'useNameAsBarcode';

interface ScratchPlateBarcodeInputProps {
  isSinglePlate: boolean;
  mode: BarcodeMode;
  customBarcode: string;
  plateName: string | null;
  onModeChange: (mode: BarcodeMode) => void;
  onCustomBarcodeChange: (value: string) => void;
}

export default function ScratchPlateBarcodeInput({
  isSinglePlate,
  mode,
  customBarcode,
  plateName,
  onModeChange,
  onCustomBarcodeChange,
}: ScratchPlateBarcodeInputProps): JSX.Element {
  const {classes} = useStyles();
  const canUseNameAsBarcode = !isSinglePlate || (plateName != null && plateName !== '');
  return (
    <FormGroup>
      <FieldLabel label="Barcode" labelStyle={FieldLabel.STYLES.LABEL} />
      <Radio.Group
        value={mode}
        onChange={(v) => {
          onModeChange(v as BarcodeMode);
        }}
      >
        <Stack spacing="xs" mt="xs">
          <Radio value="autogenerate" label="Autogenerate" classNames={{label: classes.radioLabel}} />
          {isSinglePlate && <Radio value="custom" label="Custom" classNames={{label: classes.radioLabel}} />}
          <Radio
            value="useNameAsBarcode"
            label="Use name as barcode"
            disabled={!canUseNameAsBarcode}
            classNames={{label: classes.radioLabel}}
          />
        </Stack>
      </Radio.Group>
      {mode === 'custom' && (
        <TextInput
          size="md"
          mt="md"
          placeholder="Barcode"
          value={customBarcode}
          onChange={(e) => {
            onCustomBarcodeChange(e.currentTarget.value);
          }}
        />
      )}
    </FormGroup>
  );
}

const useStyles = createStyles((theme) => ({
  radioLabel: {
    fontSize: theme.fontSizes.sm,
  },
}));
